import React, {useContext, useState} from 'react';
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Box,
    Link,
    Dialog,
    DialogContent,
    IconButton,
    DialogActions
} from '@mui/material';
import {Link as RouterLink} from "react-router-dom";
import {repairUrl} from "../utils/misc";
import ConfigContext from "../context/ConfigContext";
import TurnedInRoundedIcon from '@mui/icons-material/TurnedInRounded';
import TurnedInNotRoundedIcon from '@mui/icons-material/TurnedInNotRounded';
import {format} from "date-fns";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const renderExtraData = (data) => {
    // Check if data is an object or array and render it recursively
    if (Array.isArray(data)) {
        return (
            <Box sx={{marginLeft: 2}}>
                {data.map((item, index) => (
                    <Box key={index} sx={{marginBottom: 1}}>
                        {renderExtraData(item)} {/* Recursively render nested items */}
                    </Box>
                ))}
            </Box>
        );
    }

    if (typeof data === 'object' && data !== null) {
        return (
            <Box sx={{marginLeft: 2}}>
                {Object.entries(data).map(([key, value]) => (
                    <Box key={key} sx={{marginBottom: 1}}>
                        <Typography variant="body2" color="textSecondary">
                            <strong>{key}:</strong> {renderExtraData(value)}
                        </Typography>
                    </Box>
                ))}
            </Box>
        );
    }

    // For primitive values (string, number, etc.)
    return <span>{data}</span>;
};


const Entry = ({ entryData, toggleSaved }) => {
    const { baseUrl } = useContext(ConfigContext);
    const [openImageDialog, setOpenImageDialog] = useState(false);

    const handleImageClick = () => {
        setOpenImageDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenImageDialog(false);
    };

    if (!entryData) {
        return <Typography>Nincs elérhető adat</Typography>;
    }

    return (
        <>
            <Card>
                {entryData.image && (
                    <CardMedia
                        component="img"
                        image={repairUrl(entryData.image, baseUrl)}
                        alt="Entry Image"
                        height='300'
                        onClick={handleImageClick}
                        sx={{
                            cursor: 'pointer',
                            objectFit: 'fill'
                        }}
                    />
                )}
                <CardContent sx={{padding: 1, paddingBottom: '8px !important'}}>
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <Link
                            component={RouterLink}
                            to={`/cameras/${entryData.camera?.id}`}
                            variant="h5"
                            color="primary"
                            // sx={{ marginTop: 2, display: 'inline-block' }}
                        >
                            {entryData.camera?.name}
                        </Link>
                        <IconButton
                            onClick={() => toggleSaved(entryData?.id)}
                            color={entryData.saved ? 'warning' : 'default'}
                            aria-label="toggle saved"
                        >
                            {entryData.saved ? <TurnedInRoundedIcon/> : <TurnedInNotRoundedIcon/>}
                        </IconButton>
                    </Box>
                    <Typography variant="body2" color="textSecondary">
                        {format(new Date(entryData.created_at), 'dd/MM/yyyy HH:mm:ss')}
                    </Typography>
                    {/*<Typography variant="body2" color="textSecondary">*/}
                    {/*    Frissítve ekkor: {new Date(entryData.updated_at).toLocaleString()}*/}
                    {/*</Typography>*/}
                    {entryData.extra_data && (
                        <Box sx={{marginTop: 1}}>
                            <Typography variant="body2" color="textSecondary">
                                <strong>Extra adatok:</strong>
                            </Typography>
                            {renderExtraData(entryData.extra_data)} {/* Recursively render extra_data */}
                        </Box>
                    )}
                </CardContent>
            </Card>

            {/* Dialog for fullscreen image */}
            {/*{entryData.image && (*/}
            {/*    <Dialog open={openImageDialog} onClose={handleCloseDialog} maxWidth="lg">*/}
            {/*        <DialogContent sx={{ padding: 0 }}>*/}
            {/*            <img*/}
            {/*                src={repairUrl(entryData.image, baseUrl)}*/}
            {/*                alt="Entry Fullscreen"*/}
            {/*                style={{ width: '80vw', height: '80vh', objectFit: 'contain' }}*/}
            {/*            />*/}
            {/*        </DialogContent>*/}
            {/*    </Dialog>*/}
            {/*)}*/}

            {entryData.image && (
                <Dialog
                    open={openImageDialog}
                    onClose={handleCloseDialog}
                    fullScreen
                    sx={{
                        '& .MuiDialog-paper': {
                            margin: 0,
                            width: '100vw',
                            height: '100vh',
                            maxWidth: '100vw',
                            maxHeight: '100vh',
                        },
                    }}
                >
                    {/* Close Button */}
                    <IconButton
                        onClick={handleCloseDialog}
                        sx={{
                            position: 'absolute',
                            top: 32,
                            right: 16,
                            zIndex: 1000,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* Dialog Content */}
                    <DialogContent
                        sx={{
                            padding: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#000',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <img
                            src={repairUrl(entryData.image, baseUrl)}
                            alt={`Entry Image`}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    </DialogContent>

                    {/* Navigation Buttons */}
                    {/*<DialogActions*/}
                    {/*    sx={{*/}
                    {/*        position: 'absolute',*/}
                    {/*        top: '50%',*/}
                    {/*        left: 0,*/}
                    {/*        width: '100%',*/}
                    {/*        display: 'flex',*/}
                    {/*        justifyContent: 'space-between',*/}
                    {/*        padding: 0,*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <IconButton*/}
                    {/*        onClick={handlePrevImage}*/}
                    {/*        disabled={data.latest_images.length <= 1}*/}
                    {/*        sx={{*/}
                    {/*            backgroundColor: 'rgba(0, 0, 0, 0.5)',*/}
                    {/*            color: 'white',*/}
                    {/*            margin: 2,*/}
                    {/*            '&:hover': {*/}
                    {/*                backgroundColor: 'rgba(0, 0, 0, 0.7)',*/}
                    {/*            },*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <ArrowBackIosIcon />*/}
                    {/*    </IconButton>*/}
                    {/*    <IconButton*/}
                    {/*        onClick={handleNextImage}*/}
                    {/*        disabled={data.latest_images.length <= 1}*/}
                    {/*        sx={{*/}
                    {/*            backgroundColor: 'rgba(0, 0, 0, 0.5)',*/}
                    {/*            color: 'white',*/}
                    {/*            margin: 2,*/}
                    {/*            '&:hover': {*/}
                    {/*                backgroundColor: 'rgba(0, 0, 0, 0.7)',*/}
                    {/*            },*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <ArrowForwardIosIcon />*/}
                    {/*    </IconButton>*/}
                    {/*</DialogActions>*/}
                </Dialog>
            )}
        </>
    );
};

export default Entry;

